const isMac = typeof navigator === 'object' && /mac/i.test(navigator.platform);

export default (event: React.MouseEvent) =>
  // Cmd pressed on Mac
  (isMac && event.metaKey) ||
  // Ctrl pressed on PC
  (!isMac && event.ctrlKey) ||
  // Mousewheel clicked
  (typeof event.nativeEvent === 'object' && event.nativeEvent.which === 2);
